
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSettings } = FiIcons;

const CookiePreferencesButton = () => {
  const [showButton, setShowButton] = useState(false);

  React.useEffect(() => {
    // Only show the button if user has given consent
    const consent = localStorage.getItem('trbe-cookie-consent');
    if (consent) {
      setShowButton(true);
    }
  }, []);

  const openCookieSettings = () => {
    // Trigger cookie settings modal
    window.dispatchEvent(new CustomEvent('openCookieSettings'));
  };

  if (!showButton) return null;

  return (
    <motion.button
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={openCookieSettings}
      className="fixed bottom-4 left-4 bg-white border border-gray-300 rounded-full p-3 shadow-lg hover:shadow-xl transition-all duration-200 z-40 group"
      title="Cookie Preferences"
    >
      <SafeIcon 
        icon={FiSettings} 
        className="h-5 w-5 text-gray-600 group-hover:text-brand-orange transition-colors" 
      />
    </motion.button>
  );
};

export default CookiePreferencesButton;
